import { render } from "./FormGenerator.vue?vue&type=template&id=55a8f03c"
import script from "./FormGenerator.vue?vue&type=script&lang=js"
export * from "./FormGenerator.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__